import './AppTaggingTool.scss'
import React, { Component } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

import Listing from './tagging_tool/containers/Listing/Listing'
import CreateReport from './tagging_tool/containers/CreateReport/CreateReport'
import DimensionDetail from './tagging_tool/containers/DetailReport/DimensionDetail'
import SeoReport from './tagging_tool/containers/SeoReport/SeoReport'
import DimensionGroups from './tagging_tool/containers/DimensionGroups/DimensionGroupsAdmin'
import DimensionGroupInfo from './tagging_tool/containers/DimensionGroups/DimensionGroupInfo/DimensionGroupInfo'
import AIRegexBetaPage from './tagging_tool/containers/AIRegexBeta/AIRegexBetaPage'
import Header from './components/Headers/Header'

class App extends Component {
  render() {
    return (
      <div className="App AppTaggingTool">
        <div className="w-main" id="all">
          <Router>
            <Header iconClass="fa-solid fa-tags fa-xl" title="Tagging Tool" />
              <Switch>
                <Route
                  path="/reporting/reports/seo/:id"
                  exact
                  render={(props) => <SeoReport {...props} />}
                />
                <Route
                  path="/reporting/dimension-groups/info/:name"

                  render={(props) => <DimensionGroupInfo {...props} />}
                />
                <Route
                  path="/reporting/dimension-groups"
                  render={() => <DimensionGroups />}
                />
                <Route
                  path="/reporting/ai-regex-beta"
                  exact
                  render={() => <AIRegexBetaPage />}
                />
                <Route
                  path="/reporting/saved-dimensions/:id"
                  exact
                  render={(props) => <DimensionDetail {...props} />}
                />
                <Route
                  path="/reporting/custom-dimensions/:id"
                  exact
                  render={(props) => <DimensionDetail {...props} />}
                />
                <Route
                  path="/reporting/custom-metrics/:id"
                  exact
                  render={(props) => <DimensionDetail {...props} />}
                />
                <Route
                  path="/reporting/create"
                  render={() => <CreateReport />}
                />
                <Route path="/reporting/" component={() => <Listing />} />
                <Route
                  path="/"
                  render={() => <Redirect to="/reporting/" />}
                />
              </Switch>
          </Router>
        </div>
        <div id="modal-portal" />
      </div>
    )
  }
}

export default App
